import React from 'react';
import classNames from 'classnames';
import JBImage from 'components/essentials/JBImage';
import TextContent from 'components/consumer/TextContent';

const ImageAndContent = ({
  config: {
    elementAttribute,
    imageComponent,
    componentSelection,
    textContentSection,
    buttonSection,
  },
  columnMode = false,
}) => {
  // container config
  const layoutSize = imageComponent?.size ?? 'Full Width';
  const containerBackground =
    componentSelection?.componentSelectionConfig?.backgroundColor;
  const finalOrientation =
    componentSelection?.componentSelectionConfig?.textOrientation === 'Left'
      ? 'default'
      : 'alt';
  const imageUrl = componentSelection?.imageUrl ?? '';

  return (
    <div
      className={classNames('w-full flex justify-center', {
        'px-5 md:px-[3.333vw] min-[1500px]:px-[50px]':
          !columnMode && layoutSize === 'Full Page',
      })}
    >
      <div
        className={classNames(
          'flex justify-between [&_a:hover]:underline',
          'mx-auto my-0 py-0',
          {
            'flex-row max-[767px]:flex-col !pl-0':
              finalOrientation === 'default',
            'flex-row-reverse max-[767px]:flex-col !pr-0':
              finalOrientation === 'alt',
            'w-full': layoutSize === 'Full Width',
            'max-w-[1400px]': layoutSize === 'Full Page',
            '!flex-col': columnMode,
          }
        )}
        style={{
          backgroundColor: containerBackground ?? '',
        }}
        id={elementAttribute?.id}
      >
        <div>
          <JBImage className="w-full" height={800} width={800} src={imageUrl} />
        </div>

        <div
          className={classNames(
            'max-[767px]:w-full [&_img]:w-full [&_img]:align-middle [&_img]:[transition:all_.25s_ease-in-out] flex flex-row !m-0',
            'py-5 md:py-[3.333vw] min-[1500px]:py-[50px]',
            'grow',
            {
              'px-5 md:px-[3.333vw] min-[1500px]:px-[50px]': !columnMode,
              'max-[767px]:pt-6':
                finalOrientation === 'default' || finalOrientation === 'alt',
              'w-1/2': !columnMode,
            }
          )}
        >
          <TextContent
            config={{
              imageComponent,
              backgroundSelection: {
                backgroundColor:
                  componentSelection?.componentSelectionConfig?.backgroundColor,
              },
              textContentSection,
              buttonSection,
            }}
            variant={columnMode ? 'MultipleBlocks' : 'ImageAndContent'}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageAndContent;
